import axios from 'axios';

let Test : any = {};
Test.submitForm = async (data:any) =>{
    return await axios.post(`${process.env.REACT_APP_BASE_URL}/api/test/eligi`, data
      )
    
}

export default Test;